import { useState, useEffect } from "react";
import type { FC } from "react";
import { getBots } from "../api/client";
import type { BotListItem } from "../api/client";
import { LoadingSpinner, ErrorMessage } from "../components/Common";

interface Props {
  user: ReturnType<typeof import("../hooks/useTelegram").useTelegram>["user"];
  onSelect: (botId: string) => void;
  onCreate: () => void;
}

export const ProjectsPage: FC<Props> = ({ user, onSelect, onCreate }) => {
  const [bots, setBots] = useState<BotListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchBots = () => {
    if (!user?.id) {
      setError("Iltimos, Telegram orqali kiring.");
      setLoading(false);
      return;
    }
    setLoading(true);
    setError("");
    getBots(user.id)
      .then(setBots)
      .catch((e) => setError(e instanceof Error ? e.message : "Xatolik"))
      .finally(() => setLoading(false));
  };

  useEffect(fetchBots, [user?.id]);

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error} onRetry={fetchBots} />;

  return (
    <div className="projects-page">
      <header className="page-header">
        <h1>Botlarim</h1>
        {user && <p className="user-greeting">Salom, {user.first_name}</p>}
      </header>

      {bots.length === 0 ? (
        <div className="empty-state">
          <span className="empty-icon">🤖</span>
          <h2>Hali botlar yo'q</h2>
          <p className="hint-text">Birinchi botingizni yarating — biznesingiz nomidan mijozlar bilan suhbatlashsin.</p>
          <button onClick={onCreate} className="btn btn-primary btn-lg">
            + Yangi bot yaratish
          </button>
        </div>
      ) : (
        <>
          <div className="bot-list">
            {bots.map((bot) => (
              <button
                key={bot.id}
                onClick={() => onSelect(bot.id)}
                className="bot-card"
              >
                <div className="bot-card-top">
                  <span className="bot-avatar">🤖</span>
                  <div className="bot-info">
                    <h3>{bot.businessName}</h3>
                    <p className="bot-username">@{bot.botUsername}</p>
                  </div>
                  <span className={`status-dot ${bot.status === "active" ? "active" : "inactive"}`} />
                </div>
                <div className="bot-card-bottom">
                  <span className="hint-text">{new Date(bot.createdAt).toLocaleDateString("uz-UZ")}</span>
                </div>
              </button>
            ))}
          </div>

          <button onClick={onCreate} className="btn btn-primary btn-fab">
            + Yangi bot
          </button>
        </>
      )}
    </div>
  );
};
